import React from "react";
import { Modal, Button, Form, Input, DatePicker, Select, message } from "antd";
import { connect } from "react-redux";
import { addPayout, getPayoutList } from "../../../actions/payout/";
import { useState } from "react";
import { bindActionCreators } from "redux";
import dayjs from "utils/dateUtils";


const { Option } = Select;

const AddPayoutModal = ({
    visible,
    onClose,
    onSubmit,
    rideId,
    payoutList,
    rideDetails,
    userId,
    addPayoutAction,
    fetchPayoutList,
}) => {
    const [loading, setLoading] = useState(false)
    const [amountError, setAmountError] = useState("");
    const [form] = Form.useForm();

    const payoutData = payoutList?.data || payoutList || {};
    const currentBalance = (payoutData.netAmountPayable - payoutData.amountSettled) || 0;

    const validateAmount = (value) => {
        const amount = parseFloat(value);
        if (amount > currentBalance) {
            setAmountError("Payout value can't be greater than current balance!");
            return false;
        } else {
            setAmountError("");
            return true;
        }
    };


    const onFinish = async (values) => {
        if (!validateAmount(values.amountPaid)) {
            return;
        }

        setLoading(true);

        try {

            const formattedDate = values.paymentDate ?
                values.paymentDate.format('YYYY-MM-DD') :
                dayjs().format('YYYY-MM-DD');

            const payoutData = {
                productId: rideId,
                productType: "RIDES",
                paidAmount: values.amountPaid.toString(),
                payoutMode: values.payMode,
                payoutStatus: "SUCCESS",
                payoutOrderId: values.transactionId,
                message: values.message || "Payment processed",
                paymentDate: formattedDate,
            };

            const result = await onSubmit(payoutData);

            if (result && result.success) {
                form.resetFields();
                onClose();
                message.success("Payout added successfully!");

                getPayoutList(rideId);

            } else {
                message.error(result?.error || "Failed to add payout");
            }
        } catch (error) {
            message.error("An error occurred while adding payout");
        } finally {
            setLoading(false);
        }
    };

    const onFinishFailed = () => {
        message.error("Please fill in all required fields correctly");
    };

    const handleCancel = () => {
        form.resetFields();
        onClose();
    };

    const handleAmountChange = (e) => {
        const value = e.target.value;
        if (value) {
            validateAmount(value);
        } else {
            setAmountError("");
        }
    };


    const labelStyles = {
        width: "130px",
        marginRight: "16px",
        fontSize: '16px',
        fontWeight: '400',
        height: '28px',
        lineHeight: '28px',
        color: '#0A0B10'
    }

    const formInputStyles = {
        border: '1px solid #D0D4E1',
        borderRadius: '2px',
        color: '#FFF',
        padding: '12px'
    }

    const modalTitleStyles = {
        fontSize: '22px',
        fontWeight: '700',
        height: '27px',
        lineHeight: '100%',
        color: '#919191'
    }



    return (
        <Modal
            title={
                <span style={modalTitleStyles}>
                    Add Payout
                </span>
            }
            open={visible}
            onCancel={handleCancel}
            footer={null}
            centered
            width={572}
            bodyStyle={{ padding: "24px" }}
            destroyOnClose={true}
        >
            <Form
                form={form}
                name="addPayout"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                layout="vertical"
            >
                {/* Payment Date Field */}
                <div style={{ display: "flex", alignItems: "center", marginBottom: "24px" }}>
                    <label style={labelStyles}>
                        Payment Date :
                    </label>
                    <Form.Item
                        name="paymentDate"
                        style={{ margin: 0, flex: 1 }}
                        rules={[
                            {
                                required: true,
                                message: "Please select payment date!",
                            },
                        ]}
                    >
                        <DatePicker
                            placeholder="Select Date"
                            style={{ width: "100%" }}
                            format="DD/MM/YYYY"
                            disabledDate={(current) => current && current > dayjs().endOf('day')}
                        />
                    </Form.Item>
                </div>

                {/* Transaction ID Field */}
                <div style={{ display: "flex", alignItems: "center", marginBottom: "24px" }}>
                    <label style={labelStyles}>
                        Transaction ID :
                    </label>
                    <Form.Item
                        name="transactionId"
                        style={{ margin: 0, flex: 1 }}
                        rules={[
                            {
                                required: true,
                                message: "Please input transaction ID!",
                            },
                        ]}
                    >
                        <Input placeholder="Enter Transaction Id" />
                    </Form.Item>
                </div>

                {/* Pay Mode Field */}
                <div style={{ display: "flex", alignItems: "center", marginBottom: "24px" }}>
                    <label style={labelStyles}>
                        Pay Mode :
                    </label>
                    <Form.Item
                        name="payMode"
                        style={{ margin: 0, flex: 1 }}
                        rules={[
                            {
                                required: true,
                                message: "Please select payment mode!",
                            },
                        ]}
                    >
                        <Select placeholder="Select Pay Mode">
                            <Option value="UPI">UPI</Option>
                            <Option value="NEFT">NEFT</Option>
                            <Option value="RTGS">RTGS</Option>
                        </Select>
                    </Form.Item>
                </div>

                {/* Amount Paid Field */}
                <div style={{ display: "flex", alignItems: "flex-start", marginBottom: "32px" }}>
                    <label style={labelStyles}>
                        Amount Paid :
                    </label>
                    <div style={{ flex: 1 }}>
                        <Form.Item
                            name="amountPaid"
                            style={{ margin: 0 }}
                            rules={[
                                {
                                    required: true,
                                    message: "Please input amount!",
                                },
                                {
                                    pattern: /^\d+(\.\d{1,2})?$/,
                                    message: "Please enter a valid amount!",
                                },
                            ]}
                        >
                            <Input
                                placeholder="Enter Amount"
                                type="number"
                                min="0"
                                step="0.01"
                                prefix={<span style={{ color: "#000" }}>Rs.</span>}
                                onChange={handleAmountChange}
                                style={{
                                    borderColor: amountError ? "#ff4d4f" : "#D0D4E1",
                                }}
                            />
                        </Form.Item>
                        {amountError && (
                            <div style={{
                                color: "#ff4d4f",
                                fontSize: "12px",
                                marginTop: "4px"
                            }}>
                                {amountError}
                            </div>
                        )}
                        <div style={{
                            fontSize: "12px",
                            color: "rgb(255, 77, 79)",
                            fontWeight: "800"
                        }}>
                            {amountError ? `Current Balance: Rs. ${currentBalance.toLocaleString('en-IN')}` : ""}
                        </div>
                    </div>
                </div>

                {/* Submit Button */}
                <Form.Item style={{ marginTop: "24px", marginBottom: "0" }}>
                    <Button
                        type="primary"
                        htmlType="submit"
                        block
                        loading={loading}
                        style={{
                            backgroundColor: "#6528D8",
                            borderColor: "#6528D8",
                            borderRadius: "25px",
                            height: "40px",
                            fontWeight: "600",
                            fontSize: "16px",
                        }}
                    >
                        {loading ? "Adding..." : "Okay"}
                    </Button>
                </Form.Item>
            </Form>
        </Modal >
    );
};


function mapStateToProps(state) {
    const {
        Payout: { payoutList } = {},
        Login: { currentUser } = {},
    } = state;

    return {
        payoutList: payoutList || {},
        currentUser: currentUser || {},
    };
}

function mapDispatchToProps(dispatch) {
    return {
        addPayoutAction: bindActionCreators(addPayout, dispatch),
        fetchPayoutList: bindActionCreators(getPayoutList, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddPayoutModal);
